import { render, staticRenderFns } from "./QuickStartProtocol.vue?vue&type=template&id=396abfa7&scoped=true&"
import script from "./QuickStartProtocol.vue?vue&type=script&lang=js&"
export * from "./QuickStartProtocol.vue?vue&type=script&lang=js&"
import style0 from "./QuickStartProtocol.vue?vue&type=style&index=0&id=396abfa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396abfa7",
  null
  
)

export default component.exports